// Loader pre schvalovanie live ticketov a vtedy ked je vrateny nejaky timeout na schvalnie z ticketovej sluzby
more.asideLoading = {
    get loader() {
        return document.getElementById("asideLoader");
    },
    get inProgress() {
        return ticket.isTicketInProgress();
    },
    timer: null,
    reset: function () {
        try {
            document.documentElement.classList.remove('ui-loader--hidden');
            if (this.loader) {
                this.loader.classList.add('aside-loader--hidden');
                this.timer ? clearInterval(this.timer) : null;
                this.timer = null;
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + catchFunctionCall(arguments), e);
            return false;
        }
    },
    toggle : function ({show, timeInSec}) {
        try {
            if (show) {
                // skryjem ui-loader v hlavicke
                document.documentElement.classList.add('ui-loader--hidden');
                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
                // zobrazujem loader a nastavujem pocet sekund na odpoctavanie
                if (this.loader) {
                    var title = this.loader.querySelector(".aside-loader__title");
                    var countdown = this.loader.querySelector(".aside-loader__countdown");

                    // Nastavi text a spusti odpoctavanie
                    title.textContent = texts.LiveTicketLoading;

                    // Nastavi pocet sekund
                    timeInSec = Math.ceil(parseInt(timeInSec) || 0);
                    // prve zobrazenie odpoctu
                    countdown.textContent = timeInSec;
                    // Pri pouziti arrow funkcie sa this dedi, pri obycajnej funkcii nie.
                    this.timer = setInterval(() => {
                        if (timeInSec > 0) {
                            timeInSec--;
                            countdown.textContent = timeInSec;
                        } else {
                            this.reset();
                        }
                    }, 1000);
                    this.loader.classList.remove('aside-loader--hidden');
                    // Odoberiem class pre zakazanie interakcie ktoru dava ui-loader lebo chcem iteragovat s UI
                    $("body").removeClass("ui-disabled");
                    return true;
                }   
            } else {
                this.reset();
            }
        } catch (e) {
            this.reset();
            console.error("ERROR catched in function: " + catchFunctionCall(arguments), e);
            return false;
        }
    }
}